import type { Fixture } from '@h2h/shared';
import type { DuelVM } from '../../../lib/cyclingRound';
import { StageDuelRow } from './StageDuelRow';
import { StageResultRow } from './StageResultRow';

/** Single grouped card for all stage duels — tighter than six separate tiles. */
export function StageDuelList({
  duels,
  fixtures,
  stageLive,
  onOpenDuel
}: {
  duels: DuelVM[];
  fixtures: Fixture[];
  stageLive: boolean;
  onOpenDuel: (duelId: string) => void;
}) {
  const hasEntry = duels.length > 0;
  const title = hasEntry ? 'Your calls' : 'Stage duels';
  const subtitle = hasEntry ? 'Banker first' : `${fixtures.length} duels`;

  return (
    <div className="mt-3">
      <div className="mb-2 flex items-baseline justify-between px-0.5">
        <span className="text-[10px] font-extrabold uppercase tracking-[0.1em] text-ink3">{title}</span>
        <span className="text-[10px] font-semibold text-ink4">{subtitle}</span>
      </div>

      <div className="overflow-hidden rounded-[18px] border border-black/10 bg-white shadow-tile">
        {hasEntry
          ? duels.map((vm, i) => (
              <StageDuelRow
                key={vm.duelId}
                vm={vm}
                stageLive={stageLive}
                onOpen={() => onOpenDuel(vm.duelId)}
                last={i === duels.length - 1}
              />
            ))
          : fixtures.map((f, i) => (
              <StageResultRow
                key={f.fixtureId}
                fixture={f}
                onOpen={() => onOpenDuel(f.fixtureId)}
                last={i === fixtures.length - 1}
              />
            ))}
      </div>
    </div>
  );
}
